export default __webpack_public_path__ + "static/media/iconAudio.dd276da1.svg";